/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ReactNode } from 'react';
import React from 'react';

import styles from './styles.module.scss';

interface IProps {
  title?: string | ReactNode;
  children?: ReactNode;
}

function InfoCard({ title, children }: IProps) {
  return (
    <div className={styles.infoCard}>
      <div className={styles.title}>
        <b>{title}</b>
      </div>

      <div className={styles.content}>{children}</div>
    </div>
  );
}

export default InfoCard;
